<template>
  <article class="switch-button">
    <p class="text" v-if="textBefore">{{ text }}</p>
    <toggle-button :value="value" :color="colors.blue" @change="onChange" />
    <p class="text" v-if="!textBefore">{{ text }}</p>
  </article>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      require: true,
    },
    text: {
      type: String,
      default: '',
    },
    textBefore: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    // On emet la valeur
    onChange(val) {
      this.$emit('input', val.value);
    },
  },
};
</script>

<style lang="scss" scoped src="./SwitchButton.scss"></style>
